import { defineMessages } from 'react-intl';

export default defineMessages({
  nextButton: {
    id: 'Next',
    defaultMessage: 'Next'
  },
  copiedLinkAlert: {
    id: 'Link copied!',
    defaultMessage: 'Link copied!'
  }
});
